import React from "react";
import { Navigate } from "react-router-dom";
import { useLocalStorage } from "../../../hooks/useLocalStorage";

const AuthRoute = ({ children }) => {
  const { getItem } = useLocalStorage();
  const logInStatus = getItem("isLogin");

  if (!logInStatus) {
    return <Navigate to="/" />;
  }

  return children;
};

export default AuthRoute;
